<script setup lang="ts">
const t2 = useT2({
  'View More': 'Daugiau',
  // 'View More': 'Žiūrėti daugiau',
})
defineProps<{ submit(): NotVoid; txt?: stringI18n; cursor: string | None; border?: boolean; classAdd?: string | string[]; width?: '_w100p' }>()
const notify = useNotify()
</script>

<template>
  <div :class="classAdd || '_pt2'">
    <UiNotify :notify />
    <ButtonUi2 v-if="cursor" :ref="notify.elem" :border nochev :on="false" big :txt="txt || t2('View More')" @click.passive="() => notify.watch(submit())" :class="width">
      <svg class="_svg20 _mr14" viewBox="0 0 24 24" fill="currentColor" focusable="false">
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" />
      </svg>
    </ButtonUi2>
  </div>
</template>
